import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { translate } from '@haldor/ui';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import { getRootUrl } from "helpers/url";
import { isUserStudent } from "helpers/user";
import { COMPULSORY_SCHOOL, PRESCHOOL, ADULT_EDUCATION, UPPER_SECONDARY_EDUCATION } from "constants/schoolTypes";
import User from '_class/User';
import { getAssessment, getPlanAssessments } from "actions/assessments";
import { addError } from "actions/index";
import { getPlanDetails } from "actions/plans";
import { fetch_preschoolgoals } from "actions/preschoolform";
import { getSection } from "actions/sections";
import { getBlocksByReference } from 'actions/blocks';
import SelectedCoreContent from "containers/CoreContent/Selected";
import UserPlanning from "components/List/UserPlanning";
import DateSpan from "components/Presentation/Date/DateSpan";
import BlockConsumer from 'components/BlockEditor/Consumer';
import AssessmentsConsumer from 'components/BlockAssessments/Consumer';
import { Icon, Button, Block as ContentBlock } from '@haldor/ui';
import { List, Spinner } from "UI";
import Block, { BlockContent, BlockWrapper } from "UI/Elements/Block";

var PrintPlan = /*#__PURE__*/function (_Component) {
  _inherits(PrintPlan, _Component);

  var _super = _createSuper(PrintPlan);

  function PrintPlan() {
    var _this;

    _classCallCheck(this, PrintPlan);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var user, isPreschool;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              user = new User(_this.props.currentUser);
              isPreschool = user.getActiveSchool().type == PRESCHOOL;

              if (!(_this.props.match.params.planId > 0)) {
                _context.next = 11;
                break;
              }

              _context.next = 5;
              return _this.props.getPlanDetails(_this.props.match.params.planId);

            case 5:
              _context.next = 7;
              return _this.props.getBlocksByReference(_this.props.match.params.planId, 'PLAN');

            case 7:
              _context.next = 9;
              return _this.props.getSection(_this.props.plan.sectionId);

            case 9:
              _context.next = 11;
              return _this.props.getPlanAssessments(_this.props.match.params.planId);

            case 11:
              console.log(_this.props.plan);

              if (_this.props.goals.length < 1 && isPreschool) {
                _this.props.fetch_preschoolgoals();
              }

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "goBack", function (event) {
      event.preventDefault();
      window.history.go(-1);
      setTimeout(function () {
        if (this != null && this.props != null) {
          var match = this.props.match;
          window.location.href = "".concat(getRootUrl(), "plan/").concat(match.params.planId);
        }
      }, 200);
      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "backButton", function () {
      var match = _this.props.match;

      if (match.params.planId) {
        return /*#__PURE__*/React.createElement(Link, {
          onClick: _this.goBack,
          style: {
            cursor: "pointer",
            color: "black",
            textDecoration: "none"
          },
          className: "teams-icon-go-back",
          to: "#"
        }, /*#__PURE__*/React.createElement("span", {
          className: "chevron",
          style: {
            paddingLeft: "0.5em"
          }
        }, _this.props.translate("back")));
      } else {
        return null;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderStatus", function (status) {
      if (status === "PLANNING_OPEN") {
        return /*#__PURE__*/React.createElement("span", {
          className: "dot dot-green"
        }, _this.props.translate("Open"));
      } else if (status === "PLANNING_CLOSED") {
        return /*#__PURE__*/React.createElement("span", {
          className: "dot dot-red"
        }, _this.props.translate("Closed"));
      } else if (status === "PLANNING_DRAFT") {
        return /*#__PURE__*/React.createElement("span", {
          className: "dot dot-gray"
        }, _this.props.translate("Draft"));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "pupilStatus", function () {
      var _plan$students;

      var status = null;
      var plan = _this.props.plan;
      console.log("ssssssssss", _this.props.plan);

      if (plan != null && (plan === null || plan === void 0 ? void 0 : (_plan$students = plan.students) === null || _plan$students === void 0 ? void 0 : _plan$students.length) > 0) {
        status = _this.props.plan.students[0].planningStatus;
      }

      if (status === "PLANNING_OPEN") {
        return /*#__PURE__*/React.createElement("span", {
          className: "dot dot-green"
        }, _this.props.translate("open"));
      } else if (status === "PLANNING_CLOSED") {
        return /*#__PURE__*/React.createElement("span", {
          className: "dot dot-red"
        }, _this.props.translate("closed"));
      } else if (status === "ASSESSMENT_PUBLISHED") {
        return /*#__PURE__*/React.createElement("span", {
          className: "dot dot-green"
        }, _this.props.translate("assessed"));
      }

      return /*#__PURE__*/React.createElement("span", {
        className: "dot dot-red"
      }, _this.props.translate("closed"));
    });

    _defineProperty(_assertThisInitialized(_this), "printDialog", function () {
      window.print();
    });

    _defineProperty(_assertThisInitialized(_this), "printGoals", function () {
      var _this$props = _this.props,
          plan = _this$props.plan,
          goals = _this$props.goals;

      if (!plan || goals.length < 1) {
        return null;
      }

      if (plan.associatedGoals && plan.associatedGoals.length > 0) {
        return /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(BlockContent, null, plan.associatedGoals.map(function (goal) {
          var foundGoal = goals.find(function (g) {
            return g.id == goal.goalId;
          });

          if (foundGoal) {
            return /*#__PURE__*/React.createElement("div", {
              key: "goal-".concat(foundGoal.id),
              style: {
                backgroundColor: foundGoal.colorCode
              },
              className: "goal-preview"
            }, foundGoal.title);
          }

          return null;
        })));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "planContent", function () {
      var _this$props$section$o, _this$props$plan$stud, _this$props$plan$asso;

      var schoolType = _this.props.currentUser.schools.getActiveSchool(_this.props.currentUser.userId).type;

      var isStudent = isUserStudent(_this.props.currentUser);
      var teacherOwnsPlan = ((_this$props$section$o = _this.props.section.owners) === null || _this$props$section$o === void 0 ? void 0 : _this$props$section$o.find(function (owner) {
        return owner.userId == _this.props.currentUser.userId;
      })) != null;
      var assessmentBlocks = [];
      var assessment = null;
      var coreContents = [];

      if (_this.props.section != null && _this.props.plan.associatedCoreContent != null) {
        _this.props.plan.associatedCoreContent.map(function (coreContent) {
          var findCourse = _this.props.section.courses.find(function (c) {
            return coreContent.coreContents && coreContent.coreContents.length > 0 && c.details[0].id == coreContent.coreContents[0].courseDetailsId;
          });

          var courseTitle = "";
          var courseId = "";

          if (findCourse != null) {
            courseTitle = findCourse.title;
            courseId = findCourse.id;
          }

          coreContents.push({
            courseTitle: courseTitle,
            courseId: courseId,
            coreContents: coreContent.coreContents
          });
        });
      }

      if (_this.props.blocks != null) {
        assessmentBlocks = _toConsumableArray(_this.props.blocks).filter(function (block) {
          return block.type == 'Haldor.Blocks.AssessmentBlock' && block.resources.length > 0;
        });

        if (isStudent && _this.props.assessments.length > 0) {
          assessment = _this.props.assessments[0];
        }
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "single-plan single-task",
        key: _this.props.plan.id
      }, /*#__PURE__*/React.createElement("div", {
        className: "single-section no-print"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: _this.printDialog
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Printer"
      }), _this.props.translate("print"))), /*#__PURE__*/React.createElement("div", {
        className: "single-section"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "block"
        }
      }, /*#__PURE__*/React.createElement("h4", {
        style: {
          marginTop: 0
        }
      }, _this.props.translate("Status")), /*#__PURE__*/React.createElement("div", null, isStudent ? _this.pupilStatus() : _this.renderStatus(_this.props.plan.status), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: "both"
        }
      }))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "2em"
        }
      }, /*#__PURE__*/React.createElement("h4", null, _this.props.translate("information")), /*#__PURE__*/React.createElement(DateSpan, {
        start: _this.props.plan.timeStart,
        end: _this.props.plan.timeEnd
      }), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "single-section form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "single-assignment-meta"
      }, /*#__PURE__*/React.createElement("span", null, _this.props.section.title)), /*#__PURE__*/React.createElement("h1", {
        style: {
          display: "inline-block",
          fontWeight: "600",
          fontSize: "2.2em"
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          color: "black"
        }
      }, _this.props.plan.title))), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: "both"
        }
      }), _this.props.blocks != null ? /*#__PURE__*/React.createElement(ContentBlock, null, /*#__PURE__*/React.createElement(BlockConsumer, {
        fields: _this.props.blocks
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "single-section-divider",
        style: {
          marginBottom: "3rem"
        }
      }), ((_this$props$plan$stud = _this.props.plan.students) === null || _this$props$plan$stud === void 0 ? void 0 : _this$props$plan$stud.length) > 0 && !isStudent && teacherOwnsPlan ? /*#__PURE__*/React.createElement(List, {
        title: _this.props.translate("students")
      }, /*#__PURE__*/React.createElement(UserPlanning, {
        items: _this.props.plan.students,
        planId: _this.props.match.params.planId,
        printable: true
      })) : null, (!isStudent || _this.props.plan.viewableCoreContent) && ((_this$props$plan$asso = _this.props.plan.associatedCoreContent) === null || _this$props$plan$asso === void 0 ? void 0 : _this$props$plan$asso.length) > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "single-section print-core-contents",
        style: {
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement(SelectedCoreContent, {
        associatedCoreContent: _this.props.plan.associatedCoreContent,
        assessmentBlocks: assessmentBlocks
      })) : null, (schoolType == COMPULSORY_SCHOOL || schoolType == ADULT_EDUCATION || schoolType == UPPER_SECONDARY_EDUCATION) && assessmentBlocks.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "single-section print-core-contents"
      }, /*#__PURE__*/React.createElement(AssessmentsConsumer, {
        fields: assessmentBlocks,
        assessment: assessment,
        isStudent: isStudent
      })) : null, schoolType == PRESCHOOL ? /*#__PURE__*/React.createElement(BlockWrapper, {
        cols: "2"
      }, _this.printGoals()) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          clear: "both"
        }
      }));
    });

    return _this;
  }

  _createClass(PrintPlan, [{
    key: "render",
    value: function render() {
      if (this.props.plan != null && this.props.section != null) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          className: "container"
        }, this.planContent()));
      } else {
        return /*#__PURE__*/React.createElement("div", {
          className: "container"
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }
    }
  }]);

  return PrintPlan;
}(Component);

function mapStateToProps(state) {
  return {
    plan: state.planning.active_plan,
    currentUser: state.user.currentUser,
    section: state.sections.activeSection,
    assessments: state.assessments.assessments,
    translate: translate(state.Languages.translations),
    goals: state.PreschoolGoals.preschoolGoals,
    blocks: state.Blocks.reference
  };
}

export default connect(mapStateToProps, {
  getPlanDetails: getPlanDetails,
  addError: addError,
  getAssessment: getAssessment,
  getSection: getSection,
  getPlanAssessments: getPlanAssessments,
  fetch_preschoolgoals: fetch_preschoolgoals,
  getBlocksByReference: getBlocksByReference
})(PrintPlan);